import { Component, OnInit, Inject, Attribute, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/service/order.service';
import { ShoppingComponent } from '../shopping/shopping.component';
import { ArticleService } from 'src/app/service/article.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-orderprint',
  templateUrl: './orderprint.component.html',
  styleUrls: ['./orderprint.component.scss']
})
export class OrderprintComponent implements OnInit {

  constructor(
      private articleSrv: ArticleService,
      public dialogRef: MatDialogRef<OrderprintComponent>,
      @Inject(MAT_DIALOG_DATA) public doc: any,
      private router: Router,
      public matDialog: MatDialog,
      private orderService: OrderService,
      private fb: FormBuilder
    ){
      
    this.form = this.fb.group({
      settings: ['']
    });

    }

  @Input() treeSettings: any;
  @Output() orderEmitter = new EventEmitter<Object>();
  form: FormGroup;
  article: any;
  order: any;
  attributes: any = [];
  attributeValues: any = [];
  articleAttributeList: any = [];
  state: number = 0;
  //**change to input from tree settings later**
  paperformat: any = localStorage.getItem("papertype");
  price: any = '-';
  prices: any = [];
  orderArticle: any;
  confirmed: boolean;

  async ngOnInit() {

    await this.articleSrv.getArticleById(1).then( article =>{
      this.article = article[0];
    })

    await this.articleSrv.getArticleAttributeValues(this.article.id).then( values =>{
      this.attributeValues = values;
      this.attributeValues.forEach(element => {
        //redo when input is avilable
        if(element.attribute_value_culture == this.paperformat){
          this.paperformat = element
        }
      });
    })
    
    await this.articleSrv.getPaperPrices().then( prices =>{
      this.prices = prices
    })

    await this.articleSrv.getArticleAttributes(1).then( a =>{
      let attributes: any = [];
      attributes = a;
      attributes.forEach(element => {
        //Not adding paper size attribute to selection
        let values = [];

        this.attributeValues.forEach(value => {
          if(element.attribute_id == value.attribute_id){
            values.push(value);
          }
        });

        let attribute = this.fb.group({
          article_id: element.article_id, 
          attribute_id: element.attribute_id,
          title: element.attribute_culture,
          attribute_name: element.attribute_name,
          attributeValues: this.fb.array(values),
          selected: ''
        })
        if(element.attribute_id == 11){
          attribute.value.selected = this.paperformat.attribute_value_id;
        }
        else{
          attribute.patchValue({
            selected: attribute.value.attributeValues[0]['attribute_value_id']
          })
        }
        
        this.attributes.push(attribute)
      });
      this.attributes = this.attributes.sort((a, b) => (a.value.attribute_name < b.value.attribute_name) ? -1 : 1);
      this.articleAttributes();
    })
  }

  fwdOrder($event) { 
    this.order = $event; 
    this.selectState(this.state + 1)
  }


  articleAttributes(){
    this.articleAttributeList = [];
    let paper;
    this.attributes.forEach(attribute => {
      let attributeValue = "-"
      let attributeValueId;
      attribute.value.attributeValues.forEach(value => {
        if(attribute.value.selected == value.attribute_value_id){
          attributeValue = value.attribute_value_culture
          attributeValueId = value.attribute_value_id
          if( value.attribute_id == 1){
            paper = value.attribute_value_id
          }
        }
      });
      this.articleAttributeList.push({
        attributeName: attribute.value.title,
        attributeId: attribute.value.attribute_id,
        attributeValue: attributeValue,
        attributeValueId: attributeValueId
      })
      
    });
    this.articleAttributeList = this.articleAttributeList.sort((a, b) => (a.attributeName < b.attributeName) ? -1 : 1);
    this.prices.forEach(price => {
      if((price.ev_papier_value_id == paper) && (price.ev_format_value_id == this.paperformat.attribute_value_id)){
        this.price = price
      }
    });
  }

  selectState(state){
    switch (this.state) {
      case 0:
        this.createOrderArticle();

      case 3:
        if(this.confirmed != true){
          break
        }
    }
    if(state < 2){
      this.confirmed = false
    }
    this.state = state
  }

  receiveConfirmation($event){
    this.confirmed = $event;
    if($event){
      this.selectState(2)
    }
  }

  createOrderArticle() {
    let orderArticle = {
      id: this.article.id,
      title: this.article.title,
      price: this.price['price'],
      attributes: this.articleAttributeList,
      quantity: 1
    }
    this.orderArticle = orderArticle
  }
}
